// extracted by mini-css-extract-plugin
export var error = "PartnerContactForm-module--error--540c2";
export var field = "PartnerContactForm-module--field--92ad6";
export var form = "PartnerContactForm-module--form--50e94";
export var input = "PartnerContactForm-module--input--5c244";
export var label = "PartnerContactForm-module--label--83f60";
export var nameRow = "PartnerContactForm-module--nameRow--aaa15";
export var required = "PartnerContactForm-module--required--a3081";
export var submitButton = "PartnerContactForm-module--submitButton--3f7b4";
export var textarea = "PartnerContactForm-module--textarea--76856";
export var thankYou = "PartnerContactForm-module--thankYou--b6c46";